const feedbackMixin = {
  methods: {
    doFeedback: function (message = null, type = 'error', duration = 5000) {
      if (!message) {
        message = 'Se ha producido un error'
      }
      const options = {
        message,
        type,
        duration
      }

      this.$message(options)
    }
  }
}

const handleScrollMixin = {
  data: function () {
    return {
      showTitle: false
    }
  },
  methods: {
    handleScroll: function (el) {
      const spacer = this.$refs.spacer
      const title = this.$refs.pageTitle
      if (spacer.offsetHeight + spacer.scrollTop + title.offsetHeight > el.srcElement.scrollTop) {
        this.showTitle = false
        this.$emit('showTitleOnHeader', false)
      } else {
        this.showTitle = true
        this.$emit('showTitleOnHeader', true, this.pageTitle)
      }
    }
  }
}

export { feedbackMixin, handleScrollMixin }
